import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarCard } from "@perxis-auto/ui-kit/lib/components/CarCard";
const CardTitle = memo(function CardTitle2({ isLoading = false, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarCard.TitleSkeleton, {});
  }
  return /* @__PURE__ */ jsx(CarCard.Title, { ...props });
});
export {
  CardTitle
};
